module.exports = __webpack_public_path__ + "static/media/st.9fb0ea9d.svg";